// extracted by mini-css-extract-plugin
var _1 = "CourseSlider_item__b9853";
var _2 = "CourseSlider_itemInner__9567b";
var _3 = "CourseSlider_slider__596ae";
var _4 = "CourseSlider_track__ae6f4";
export { _1 as "item", _2 as "itemInner", _3 as "slider", _4 as "track" }
